<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.messagerecipients}" class="message-recipients">
      <label for="messagerecipients">To:</label>
      <select
        v-chosen="{onChange: handleChange, chosenOptions: {width: '345px', placeholder_text_multiple: 'Select Recipient(s)'}}"
        multiple
        name="messagerecipients"
        class="form-control"
      >
        <optgroup v-if="('byRole' in config.messageRecipients)" label="By Role">
          <option
            v-for="(name, $id) in config.messageRecipients.byRole"
            :value="$id"
            :selected="messagerecipients.indexOf($id) > -1"
          >
            {{ name }}
          </option>
        </optgroup>
        <optgroup v-if="('byUser' in config.messageRecipients)" label="By User">
          <option
            v-for="(name, $id) in config.messageRecipients.byUser"
            :value="$id"
            :selected="messagerecipients.indexOf($id) > -1"
          >
            {{ name }}
          </option>
        </optgroup>
      </select>
    </div>
    <div>
      <label for="messageDeliveryMethod">Delivery method </label>
      <select :value="messageDeliveryMethod" name="messageDeliveryMethod" class="form-control" @change="handleChangeDeliveryMethod">
        <option v-for="(name, $id) in config.messageDeliveryMethods" :value="$id">
          {{ name }}
        </option>
      </select>
    </div>
    <div v-if="messageDeliveryMethod === 'dashboard'">
      <input :checked="isStickyChecked" type="checkbox" name="is_sticky" @change="handleChange">
      <span :class="{'has-error':errors.sticky_days}">
        <label>Pin to participant dashboard for</label>
        <input
          :value="sticky_days"
          :class="{'has-error': errors.sticky_days}"
          name="sticky_days"
          class="form-control input-numeric"
          @input="handleChange"
        >
        <label>days</label>
      </span>
    </div>
    <div v-if="displayEmailSubjectInput === 'optional' || displayEmailSubjectInput === 'required'">
      <label for="email_subject">Email Subject</label>
      <p
        v-if="displayEmailSubjectInput === 'optional'"
        class="form-text"
      >
        Subject is only used when participant's preference is set to email
      </p>
      <input
        :value="email_subject"
        name="email_subject"
        class="form-control w-100"
        :placeholder="config.studyEmailSubject"
        @input="handleChange"
      >
    </div>
    <div :class="{'has-error':errors.message}">
      <div class="form-text">
        If message randomization is enabled a message will be randomly selected from the options below.
      </div>
      <div v-for="(m, index) in message">
        <div
          class="form-group"
          :class="{ 'input-group': message.length > 1}"
        >
          <textarea
            :id="message[index].id"
            :key="index"
            v-model="message[index].message"
            name="message"
            rows="5"
            class="form-control custom-control"
            :class="{ 'randomized': message.length > 1}"
          />
          <span class="emojipickicon" @click.prevent="openEmojiPicker(message[index].id)" />
          <span v-if="message.length > 1" class="btn-group-vertical">
            <button class="btn btn-danger btn-sm" type="button" @click.prevent="removeMessage(index)">
              <span class="px-3 fa fa-trash-alt" />
            </button>
          </span>
        </div>
        <div v-if="isDeliveryMethodAttachable" class="form-group row">
          <div class="col-sm-2">
            <label>
              <input
                v-model="message[index].has_attachment"
                :checked="message[index].has_attachment"
                name="has_attachment"
                type="checkbox"
              >
              Attach
            </label>
          </div>

          <template v-if="message[index].has_attachment">
            <div class="col-sm-2" :class="{'has-error':errors.attachmentSelect}">
              <select
                v-model="message[index].attachment_variable_id"
                name="attachment_variable_id"
                class="form-control"
                @change="changeAttachmentType(index)"
              >
                <option value="">
                  Select Attachment
                </option>
                <optgroup label="Badge Variables">
                  <option v-for="variable in config.attachableVariables" :key="variable.id" :value="variable.id">
                    {{ variable.name }}
                  </option>
                </optgroup>
                <option value="url">
                  Other
                </option>
              </select>
            </div>
            <div class="col-sm-8" :class="{'has-error':errors.attachmentUrl}">
              <UrlInputWithUpload
                v-if="message[index].attachment_type === 'url'"
                v-model="message[index].attachment_url"
                class="attachment-uploader"
                size="sm"
              />
            </div>
          </template>
        </div>
      </div>
      <div class="input-group btn-block">
        <a
          class="btn btn-block btn-primary"
          @click.prevent="addMessage"
        >
          <template v-if="message.length === 1">Enable Message Randomization<span class="fa fa-random" /></template>
          <template v-else>Add Message Option<span class="fa fa-plus" /></template>
        </a>
      </div>

      <div class="form-text">
        You can include any of the following variables in the message. Be sure to copy/paste verbatim.
        <ul class="substitution-strings list-unstyled">
          <li v-for="string in config.messageSubstitutionStrings">
            {{ string }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import { v4 as uuidV4 } from 'uuid';
  import UrlInputWithUpload from "@ui/forms/fields/UrlInputWithUpload.vue";
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';


  export default {
    components: {
      UrlInputWithUpload
    },
    extends: BaseComponent,
    props: {
      message: {
        default: function () {
          return [
            {
              id: uuidV4(),
              message: "",
              has_attachment: false,
              attachment_type: 'url',
              attachment_variable_id: 'url',
              attachment_url: ''
            }
          ];
        }
      },
      id: String,
      messagerecipients: {
        default: function () {
          return [];
        }
      },
      messageDeliveryMethod: {
        default: 'prefs'
      },
      email_subject: {
        default: ''
      },
      is_sticky: {
        default: false
      },
      sticky_days: {},
    },
    computed: {
      isStickyChecked: function () {
        if (this.is_sticky === 'false') {
          return false;
        }
        return this.is_sticky;
      },
      displayEmailSubjectInput: function () {
        if (this.messageDeliveryMethod === 'prefs') {
          return 'optional';
        }
        if (this.messageDeliveryMethod === 'email') {
          return 'required';
        }
        return 'hidden';
      },
      isDeliveryMethodAttachable: function () {
        return this.messageDeliveryMethod !== 'dashboard' && this.messageDeliveryMethod !== 'voice';
      }
    },
    methods: {
      addMessage: function () {
        this.message.push({
          id: uuidV4(),
          message: "",
          has_attachment: false,
          attachment_type: null,
          attachment_variable_id: null,
          attachment_url: null
        });
      },
      removeMessage: function (index) {
        if (this.message.length > 1) {
          this.message.splice(index, 1);
        }
      },
      changeAttachmentType: function(index) {
        if (this.message[index].attachment_variable_id === 'url') {
          this.message[index].attachment_type = 'url';
        } else {
          this.message[index].attachment_type = 'variable';
        }
      },
      handleChangeDeliveryMethod: function(e) {
        const val = e.target.value;
        if (val === 'dashboard' || val === 'voice') {
          this.$emit('update:has_attachment', false);
        }
        this.handleChange(e);
      },
      openEmojiPicker: function (id) {
        $('textarea#' + id).emojiPicker({
          width: '400px',
          height: '300px',
          button: false
        });

        $('textarea#' + id).emojiPicker('toggle');
      },
      validate: function () {
        this.errors = {};

        // If it has previously saved with a blank recipient, then the first item will be empty
        // This was making messagerecipients have a length of 1, passing the validation check.
        // Weed out any recipients that aren't actually recipients.
        var messagerecipients = this.messagerecipients.filter(function (n) {
          return n;
        });
        if (this.is_sticky === 'false') {
          this.is_sticky = false;
        }
        if (messagerecipients.length === 0) {
          this.errors.messagerecipients = 'You must specify at least one recipient.';
        }
        if (this.is_sticky && !this.isInteger(this.sticky_days)) {
          this.errors.sticky_days = 'Please specify a number of days.';
        }
        this.message.forEach(message => {
          if (message.message == '') {
            this.errors.message = "Please enter a message to be sent.";
          }
          if (message.has_attachment && message.attachment_variable_id === '') {
            this.errors.attachmentSelect = "Please select an attachment.";
          }
          if (message.has_attachment && message.attachment_type === 'url' && !message.attachment_url) {
            this.errors.attachmentUrl = "Please enter an attachment image url.";
          }
        });
        
        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>

<style scoped>
  .feedback textarea.form-control.randomized {
    width: 93% !important;
  }
</style>
